'use client';
/**
 * @file 页面标题组件
 * @author luyinpeng
 * @date 2023-12-30
 * @description 页面标题组件，根据当前路径动态显示对应的模块标题。
 */

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

// 根据路径获取对应的标题
const getTitleByPath = (pathname: string): string => {
    // 顶级菜单路径映射
    const menuPathMap: Record<string, string> = {
        '/login': '登录',
        '/control-panel': '设置',
        '/sales': '销售',
        '/products': '产品',
        '/productions': '生产',
        '/inventories': '生产', // 库存属于生产模块
        '/finances': '财务',
        '/works': '工作',
        '/users/profile': '个人资料',
        '/users/change-password': '修改密码',
        '/users/approvals': '审批',
    };

    // 检查路径是否匹配任何顶级菜单
    for (const [path, title] of Object.entries(menuPathMap)) {
        if (pathname.startsWith(path)) {
            return title;
        }
    }

    // 默认返回首页
    return '首页';
};

interface PageTitleProps {
    customTitle?: string; // 可选的自定义标题
}

export const PageTitle = ({ customTitle }: PageTitleProps) => {
    const pathname = usePathname();
    const baseTitle = 'A-DIM';

    useEffect(() => {
        // 如果提供了自定义标题，则直接使用
        if (customTitle) {
            document.title = `${baseTitle} | ${customTitle}`;
            return;
        }

        // 否则根据路径生成标题
        const moduleTitle = getTitleByPath(pathname);
        document.title = `${baseTitle} | ${moduleTitle}`;
    }, [pathname, customTitle]);

    return null;
};
